"use strict";
exports.__esModule = true;
var clients_1 = require("../clients");
var WatcherAPI = /** @class */ (function () {
    function WatcherAPI(debug, config) {
        this.gatewayClient = new clients_1.GatewayClient(debug, config);
    }
    /**
     * 功能统计
     * @param code 功能code
     * @param userAgent 用户浏览器版本
     */
    WatcherAPI.prototype.monitorFnCount = function (params) {
        return this.gatewayClient.monitorFnCount(params);
    };
    return WatcherAPI;
}());
exports.WatcherAPI = WatcherAPI;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2F0Y2hlci1hcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpcy93YXRjaGVyLWFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLHNDQUEyQztBQUUzQztJQUdFLG9CQUNFLEtBQWMsRUFDZCxNQUtDO1FBRUQsSUFBSSxDQUFDLGFBQWEsR0FBRyxJQUFJLHVCQUFhLENBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3hELENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksbUNBQWMsR0FBckIsVUFBc0IsTUFBNEM7UUFDaEUsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ25ELENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUF2QkQsSUF1QkM7QUF2QlksZ0NBQVUifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/watcher-api.js
// module id = 227
// module chunks = 44